/**
 * Privacy & Security Policy — language toggle, sidebar nav, scroll spy.
 */
(function () {
  const root = document.querySelector('[data-bb-privacy]');
  if (!root) return;

  const configEl = root.querySelector('[data-bb-privacy-config]');
  if (!configEl) return;

  let config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }

  const navEl = root.querySelector('[data-bb-privacy-nav]');
  const navLabelEl = root.querySelector('[data-bb-privacy-nav-label]');
  const langButtons = root.querySelectorAll('[data-bb-privacy-lang]');
  const panels = root.querySelectorAll('[data-bb-privacy-panel]');
  const initialPanel = root.querySelector('[data-bb-privacy-panel].is-active');
  let activeLang =
    (initialPanel && initialPanel.getAttribute('data-bb-privacy-panel')) || 'en';
  let activeSection =
    (config.nav[activeLang] && config.nav[activeLang][0]?.id) ||
    (config.nav.en && config.nav.en[0]?.id) ||
    'data-collection';

  function getActivePanel() {
    return root.querySelector('[data-bb-privacy-panel="' + activeLang + '"]');
  }

  function renderNav() {
    if (!navEl) return;
    const items = config.nav[activeLang] || [];
    navEl.innerHTML = items
      .map(function (item) {
        const isActive = item.id === activeSection ? ' is-active' : '';
        return (
          '<button type="button" class="bb-privacy__nav-link' +
          isActive +
          '" data-bb-privacy-target="' +
          item.id +
          '">' +
          item.title +
          '</button>'
        );
      })
      .join('');

    navEl.querySelectorAll('[data-bb-privacy-target]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        scrollToSection(btn.getAttribute('data-bb-privacy-target'));
      });
    });
  }

  function getStickyOffset() {
    const header = document.getElementById('bb-header');
    const utility = document.querySelector('.utility-bar');
    let offset = 24;
    if (header) {
      offset += header.getBoundingClientRect().height;
    } else {
      offset += 120;
    }
    if (utility) {
      const style = window.getComputedStyle(utility);
      if (style.position === 'sticky' || style.position === 'fixed') {
        offset += utility.getBoundingClientRect().height;
      }
    }
    return offset;
  }

  function scrollToSection(id) {
    const panel = getActivePanel();
    if (!panel) return;
    const target = panel.querySelector('#' + id);
    if (!target) return;
    const offset = getStickyOffset();
    const top = target.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  function setLanguage(lang) {
    activeLang = lang;
    panels.forEach(function (panel) {
      const isActive = panel.getAttribute('data-bb-privacy-panel') === lang;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });

    langButtons.forEach(function (btn) {
      btn.classList.toggle(
        'is-active',
        btn.getAttribute('data-bb-privacy-lang') === lang
      );
    });

    if (navLabelEl) {
      navLabelEl.textContent =
        lang === 'zh' ? config.labels.contentsZh : config.labels.contentsEn;
    }

    activeSection = (config.nav[lang] && config.nav[lang][0]?.id) || activeSection;
    renderNav();
    updateScrollSpy();
  }

  function updateScrollSpy() {
    const panel = getActivePanel();
    if (!panel) return;

    const scrollPosition = window.scrollY + getStickyOffset() + 40;
    const sections = panel.querySelectorAll('.bb-privacy__section[id]');
    let current = activeSection;

    sections.forEach(function (section) {
      if (section.offsetTop <= scrollPosition) {
        current = section.id;
      }
    });

    if (current !== activeSection) {
      activeSection = current;
      renderNav();
    }
  }

  langButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      setLanguage(btn.getAttribute('data-bb-privacy-lang'));
    });
  });

  window.addEventListener('scroll', updateScrollSpy, { passive: true });

  renderNav();
})();
